<script setup>
import { ref } from 'vue'
import ButtonClose from '@/Shared/Buttons/ButtonClose'
import FavoriteContents from './Favorite1Contents'

const emit = defineEmits(['close'])

const active = ref('brand')

const categories = [
  { id: 'brand', name: 'ブランド' },
  { id: 'store', name: 'ストア' },
]

const changeCategory = (id) => {
  active.value = id
}
</script>

<template>
  <div class="fixed bg-white max-w-full w-[450px] h-full overflow-y-hidden top-0 right-0 shadow-[-1px_0px_1px_rgba(0,0,0,0.1)]">
    <ButtonClose class="absolute z-20 black top-0 right-0 p-[20px] origin-top-right scale-[1.5]" @click="emit('close')" />

    <!-- title -->
    <h2 class="font-bold text-center my-[30px] sm:mt-[35px] sm:mb-[40px] tracking-[0.015em]">
      <span class="block font-rift text-[68px] xs:text-[72px] sm:text-[80px] mb-[0.1em]">FAVORITE</span>
      <span class="block text-[16px] sm:text-[18px]">お気に入り</span>
    </h2>

    <!-- tab -->
    <ul class="flex w-full text-center border-t border-[#EAEAEA]">
      <li v-for="category in categories" :key="category.id" class="w-1/2">
        <a :class="{ 'bg-[#EAEAEA] text-[#888]': active !== category.id }" class="block text-[14px] p-[18px] sm:p-[20px] font-semibold" href="#" @click.prevent="changeCategory(category.id)">{{ category.name }}</a>
      </li>
    </ul>

    <!-- contents -->
    <div class="relative flex items-center flex-col overflow-x-hidden h-full">
      <transition name="slide-right2">
        <template v-if="active === 'brand'"><FavoriteContents category="brand" /></template>
      </transition>
      <transition name="slide-left2">
        <template v-if="active === 'store'"><FavoriteContents category="shop" /></template>
      </transition>
    </div>
  </div>
</template>
